import { Component } from "react";
 import Dropdown from 'react-bootstrap/Dropdown'
 import DropdownButton from 'react-bootstrap/DropdownButton'
 
 class DropdownComponent extends Component {
     constructor(props) {
         super(props)
         this.state = {
             onSelect: props.onSelect,
             store: props.storeSelected
         }
         this.selectedStore = "Store Selection"
         this.onSelect = this.selected.bind(this)
         this.countryCodeMap =  {
            "United States": "us",
            "United Kingdom": "gb",
            "Australia": "au",
            "Canada": "ca",
            "France": "fr",
            "Germany": "de",
            "Japan": "jp",
            "China": "cn",
            "India": "in",
            "Italy": "it",
            "Spain": "es"
        };
     }
 
     selected(value) {
        const [code, countryName] = JSON.parse(value);
        this.state.onSelect(code)
        this.selectedStore = countryName
     }
     
     render() {
         return(
             <div className="dropdownComponent">
                 <Dropdown>
                    <DropdownButton title={this.selectedStore} onSelect={this.onSelect}>
                        {Object.entries(this.countryCodeMap).map(([countryName, code]) => (
                            <Dropdown.Item eventKey={JSON.stringify([code, countryName])} key={code}>
                            <span className="me-2">
                                <img
                                    src={`https://flagcdn.com/w40/${code}.png`} // Use a flag CDN
                                    alt={countryName}
                                    style={{ width: "20px", height: "15px" }}
                                />
                            </span>
                            {countryName}
                            </Dropdown.Item>
                     ))}
                    </DropdownButton>
                 </Dropdown>
             </div>
         )
     }
 }
 
 export default DropdownComponent